import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleX = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			fill: "#FBD5D5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			stroke: "#F98080",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.517 12.6515L17.6916 8.35146C18.1118 7.92036 18.1008 7.22733 17.6697 6.80715C17.2386 6.38697 16.5456 6.39788 16.1254 6.82898L12 11.0799L7.87458 6.82898C7.4544 6.39788 6.76136 6.38697 6.33026 6.80715C5.89917 7.22733 5.88825 7.92036 6.30843 8.35146L10.483 12.6515L6.59765 16.6514C6.17746 17.0825 6.18838 17.7756 6.61948 18.1957C6.8323 18.4031 7.10515 18.5013 7.378 18.5013C7.65085 18.5013 7.94552 18.3922 8.1638 18.1685L12.0055 14.2122L15.8471 18.1685C16.0599 18.3867 16.3437 18.5013 16.6329 18.5013C16.9221 18.5013 17.1786 18.3976 17.3914 18.1957C17.8225 17.7756 17.8334 17.0825 17.4133 16.6514L13.5279 12.6515H13.517Z",
			fill: "#9B1C1C"
		})
	]
});
export default SvgCircleX;
